import { render, staticRenderFns } from "./allOrder.vue?vue&type=template&id=54d5e1ac"
import script from "./allOrder.vue?vue&type=script&lang=ts"
export * from "./allOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports